import { ComputerPrintEnginesSchema } from "@redotech/redo-fulfillment-group-common/print-engine";
import { PrinterSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const getPrintNodeInfo = {
  name: "getPrintNodeInfo" as const,
  input: z.object({ refresh: z.boolean().optional().default(false) }),
  output: z
    .object({
      computers: z.array(PrinterSchema.shape.computer),
      computerPrintEngines: ComputerPrintEnginesSchema,
      email: z.string(),
      hasPassword: z.boolean(),
      createdAt: z.date(),
      printers: z.array(PrinterSchema),
    })
    .nullable(),
};
